import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {useSettings} from '@ui/settings/use-settings';
import {ReactElement} from 'react';
import {Navigate, Outlet, redirect, useLocation} from 'react-router';
import {auth, useAuth} from '../use-auth';

interface Props {
  children?: ReactElement;
  permission?: string;
  requireLogin?: boolean;
}
export function AuthRoute({children, permission, requireLogin = true}: Props) {
  const {isLoggedIn, hasPermission, isSubscribed} = useAuth();
  const {billing} = useSettings();
  const location = useLocation();
  if (
    (requireLogin && !isLoggedIn) ||
    (permission && !hasPermission(permission))
  ) {
    if (isLoggedIn) {
      return billing.enable && !isSubscribed ? (
        <Navigate to="/pricing" replace />
      ) : (
        <NotFoundPage />
      );
    }
    const returnUrl = location.pathname + location.search;
    return <Navigate to={`/login?redirectUri=${encodeURIComponent(returnUrl)}`} replace />;
  }
  return children || <Outlet />;
}

interface AuthRouteLoaderProps {
  permission?: string;
  requireLogin?: boolean;
  requestUrl?: string;
}
export function authGuard({
  permission,
  requireLogin = true,
  requestUrl,
}: AuthRouteLoaderProps = {}) {
  const billingEnabled = getBootstrapData().settings.billing.enable;

  if (
    (requireLogin && !auth.isLoggedIn) ||
    (permission && !auth.hasPermission(permission))
  ) {
    if (auth.isLoggedIn) {
      return billingEnabled && !auth.isSubscribed
        ? redirect('/pricing')
        : redirect('/404');
    }
    let loginUrl = '/login';
    if (requestUrl) {
      const url = new URL(requestUrl);
      const returnPath = url.pathname + url.search;
      loginUrl += `?redirectUri=${encodeURIComponent(returnPath)}`;
    }
    return redirect(loginUrl);
  }

  return null;
}
